import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PageLayout from '../components/PageLayout';
import PageMain from '../components/ui/PageMain';
import PageBody from '../components/ui/PageBody';
import { getLatestArchivedArticles } from '../api';
import IconButton from '../components/ui/IconButton';
import { Link } from 'react-router-dom';

function Archive() {
    const { t } = useTranslation();
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        let cancelled = false;

        async function loadArchive() {
            try {
                const data = await getLatestArchivedArticles();

                if (!cancelled) {
                    setArticles(Array.isArray(data) ? data : []);
                }
            } catch (err) {
                console.error('Fehler beim Laden des Archivs:', err);

                if (!cancelled) {
                    setError('Der Papierkorb konnte nicht geladen werden.');
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        }

        loadArchive();

        return () => {
            cancelled = true;
        };

    }, []);

    function formatDateTime(value) {
        if (value == null || value === '') {
            return '—';
        }

        const numeric = Number(value);
        const date = new Date(
            Number.isFinite(numeric)
                ? (numeric < 1e12 ? numeric * 1000 : numeric)
                : value
        );

        if (Number.isNaN(date.getTime())) {
            return '—';
        }

        return new Intl.DateTimeFormat('de-DE', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        }).format(date);
    }


    return (
        <PageLayout showSearch showAiSearch>
            <PageMain className="article-page">
                <div className="page-header">
                    <div
                        className="page-header__row sticky is-condensed"
                        style={{ '--page-title-shrink': 1 }}
                    >
                        <h1>{t('common.trash')}</h1>
                    </div>
                </div>

                {loading && <p>Archiv wird geladen …</p>}

                {error && (
                    <div
                        className="login-message login-message-error"
                        role="alert"
                    >
                        {error}
                    </div>
                )}

                {!loading && !error && articles.length === 0 && (
                    <p>Der Papierkorb ist leer.</p>
                )}

                {!loading && !error && articles.length > 0 && (
                    <PageBody className="articles-list-archive">
                        {articles.map((article) => (
                            <article
                                key={article.article_id}
                                className="article-list-item"
                            >
                                <div className="article-list-content">
                                    <ul className="page-header__meta history-meta">
                                        <li>
                                            <i className="fa-regular fa-calendar" aria-hidden="true" />
                                            {formatDateTime(article.modified_date)}
                                        </li>
                                        <li>
                                            <i className="fa-regular fa-user" aria-hidden="true" />
                                            Von {article.author_name || '—'}
                                        </li>
                                        <li>
                                            <i className="fa-regular fa-file-lines" aria-hidden="true" />
                                            <Link
                                                to={`/archive/${article.article_id}/history`}
                                                state={{ from: 'archive' }}
                                                className="history-article-name"
                                                title={article.title || ''}
                                            >
                                                {article.title || '—'}
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="article-list-actions">
                                    <IconButton
                                        className="article-visibility-button"
                                        icon="fa-solid fa-clock-rotate-left"
                                        label={t('articlesPage.showFromArchive')}
                                        to={`/archive/${article.article_id}/history`}
                                        state={{ from: 'archive' }}
                                    />
                                </div>
                            </article>
                        ))}
                    </PageBody>
                )}
            </PageMain>
        </PageLayout>
    );
}

export default Archive;
